export {GDMCard} from './GDMCard';

export type { GDMCardComponent, GDMCardProps } from './GDMCard.type';
